module.exports = __webpack_public_path__ + "img/portifolio_industria.80501841.jpg";